export default __webpack_public_path__ + "static/casecard1-dcbf00a1270fe0b1e1b994065a8ea8a2.png";